import axios from "axios";
import Cookies from "universal-cookie";
import { BaseApi } from "./BaseUrl";

export async function GetAllUnits(): Promise<Array<{}>> {
    try {
        var user= new Cookies().get('user');
        const requestOptions = {
          headers: { 'Authorization':user.Token}};
        const response = await axios.get(BaseApi+'HR/GetAllUnits',requestOptions);
        return response.data;
    }
    catch (error) {
        console.error(error);
        return []; // اگر خطایی رخ دهد، یک آرایه خالی برگردانده می‌شود
    }
}

export async function GetAllUsers(): Promise<Array<{}>> {
    try {
        var user= new Cookies().get('user');
        const requestOptions = {
          headers: { 'Authorization':user.Token}};
        const response = await axios.get(BaseApi+'HR/GetAllUsers',requestOptions);
        return response.data;
    }
    catch (error) {
        console.error(error);
        return []; // اگر خطایی رخ دهد، یک آرایه خالی برگردانده می‌شود
    }
}



export async function GetUserNotices(): Promise<Array<{}>> {

    try {
        var user= new Cookies().get('user');
        const requestOptions = {
          headers: { 'Authorization':user.Token}};
        const response = await axios.get(BaseApi+'HR/GetUserNotices',requestOptions);
        return response.data;
    }
    catch (error) {
        console.error(error);
        return []; 
    }
}

export async function GetNoticeImage(name:string): Promise<string> {
    try {
        var user= new Cookies().get('user');
        const requestOptions = {
          headers: { 'Authorization':user.Token}};
        const response = await axios.get(BaseApi+'HR/GetNoticeImage?name='+name,requestOptions);
        return response.data;
    }
    catch (error) {
        console.error(error);
        return "";
    }
}



export async function SeenNotice(noticeId:any): Promise<void> {
    try {
        var user= new Cookies().get('user');
        const requestOptions = {
          headers: { 'Authorization':user.Token}};
       await axios.get(BaseApi+'HR/SeenNotice?noticeId='+noticeId,requestOptions);
         
    }
    catch (error) {
        console.error(error);
    }
}


export async function GetManagerNotices(): Promise<Array<{}>> {
    try {
        var user= new Cookies().get('user');
        const requestOptions = {
          headers: { 'Authorization':user.Token}};
        const response = await axios.get(BaseApi+'HR/GetManagerNotices',requestOptions);
        return response.data;
    }
    catch (error) {
        console.error(error);
        return []; // اگر خطایی رخ دهد، یک آرایه خالی برگردانده می‌شود
    }
}


export async function DeleteNotice(noticeId:any): Promise<void> {
    try {
        var user= new Cookies().get('user');
        const requestOptions = {
          headers: { 'Authorization':user.Token}};
         await axios.get(BaseApi+'HR/DeleteNotice?noticeId='+noticeId,requestOptions);
       
    }
    catch (error) {
        console.error(error);
    }
}

